/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getShiftsOverview} from '../api'

 export const useQueryGetShiftsOverview = createReactQueryHook('getShiftsOverview', getShiftsOverview)
